import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router/index'
import store from '@/store/index'
import axios from 'axios'
import EventBus from '@/event-bus'
import Global from '@/plugins/global'
import Swal from '@/plugins/sweetalert2'
import MultiSelect from 'vue-multiselect'
import VueFlatPickr from 'vue-flatpickr-component'
import VueWait from 'vue-wait'
import Notifications from 'vue-notification'
const ModelSelect = resolve => require(['@/components/ModelSelect'], resolve)
import moment from 'moment'
import numeral from 'numeral'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import HighchartsNoData from 'highcharts/modules/no-data-to-display.js'
import HighchartsTheme from '@/assets/highcharts-theme.js'
import VueTheMask from 'vue-the-mask'
import RouterAuth from '@/router/auth'
import VTooltip from 'v-tooltip'
import VeeValidationProvider from './vee-validate'
import { ValidationObserver } from 'vee-validate'
import 'flatpickr/dist/flatpickr.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import '@/assets/css/vue-multiselect.pcss'
import '@/assets/css/v-tooltip.pcss'
import '@/assets/css/fonts.css'
import '@/assets/main.css'
import '@fortawesome/fontawesome-free/css/all.css'

let init = () => {

  const theme = localStorage.getItem('theme')
  if (theme === 'light') {
    store.dispatch('config/changeTheme', 'light')
  } else {
    store.dispatch('config/changeTheme', 'dark')
  }

  Vue.use(VueTheMask)
  Vue.use(VTooltip)

  Highcharts.theme = HighchartsTheme
  Highcharts.setOptions(Highcharts.theme)
  HighchartsNoData(Highcharts)
  Vue.use(HighchartsVue, { Highcharts })

  moment.updateLocale(moment.locale(), { invalidDate: '-' })
  var accounting = require('accounting')

  // for fucking Highcharts stupid API
  window.accounting = accounting

  Vue.prototype.$EventBus = EventBus
  Vue.prototype.$formatMoney = accounting.formatMoney
  Vue.prototype.$formatMoneyToFixed = value => accounting.formatMoney(accounting.toFixed(value, 2))
  Vue.prototype.$moment = moment
  Vue.prototype.$numeral = numeral
  Vue.prototype.$swal = Swal

  Vue.use(Notifications)
  Vue.use(VueWait)
  Vue.use(VueFlatPickr)
  Vue.use(Global)
  Vue.component('multiselect', MultiSelect)
  Vue.component('model-select', ModelSelect)


  // vee-validate
  Vue.component('ValidationProvider', VeeValidationProvider)
  Vue.component('ValidationObserver', ValidationObserver)

  axios.defaults.baseURL = store.getters['config/config'].URL.API.host
  const token = localStorage.getItem('token')
  if (token) {
    axios.defaults.headers.common['Authorization'] = token
  }


  const wait = new VueWait()

  axios.interceptors.request.use(function (config) {
    // Create a 'unique' id for wait plugin to function properly
    // This is required only when there is multiple requests fired
    // at the same time to prevent stopping all wait(s) when 1 of those
    // finishes.
    const waitUUID = window.performance.now()
    wait.start('axios.' + waitUUID)
    config.waitUUID = waitUUID

    return config
  }, function (error) {
    return Promise.reject(error)
  })

  axios.interceptors.response.use((response) => {
    wait.end('axios.' + response.config.waitUUID)
    return response
  }, function (err) {
    if (!err.response) {
      // network error
      return err
    }

    wait.end('axios.' + err.response.config.waitUUID)
    return new Promise((resolve, reject) => {
      // todo: handle retries
      // if (err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
      if (err.response.status === 401) {
        store.dispatch('user/logout')
          .then(() => {
            router.push('/login')
            resolve()
          })
          .catch((err) => reject(err))
      } else {
        EventBus.$emit('error:http', err.response)
      }
      throw err
    })
  })

  Vue.config.productionTip = false

  router.beforeEach((to, from, next) => {
    document.body.classList.remove('no-scroll')
    if (to.name === 'login') {
      if (store.getters['user/isLoggedIn']) {
        // already logged in
        next('/')
        return
      }
    } else if (to.matched.some(record => record.meta.auth) && !store.getters['user/isLoggedIn']) {
      next('/login')
      return
    }

    // roles and permissions route matching
    for (let r in to.matched) {
      const record = to.matched[r]
      if (RouterAuth.check(record)) {
        Vue.notify({
          type: 'error',
          title: 'Error',
          text: 'Insufficient permissions'
        })
        return
      }
    }

    next()
  })

  Vue.filter('sentenceCase', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
  })

  Vue.filter('upperCase', function (value) {
    if (!value) return ''
    return value.toUpperCase()
  })

  Vue.filter('kebabCase', function (value) {
    if (!value) return ''
    return value.match(/[A-Z]{2,}(?=[A-Z][a-z0-9]*|\b)|[A-Z]?[a-z0-9]*|[A-Z]|[0-9]+/g)
      .filter(Boolean)
      .map(x => x.toLowerCase())
      .join('-')
  })

  Vue.filter('formatMoneyFixed', function (value) {
    if (!value) return '0'
    return accounting.formatMoney(accounting.toFixed(value, 2))
  })

  new Vue({
    router,
    store,
    wait,
    render: h => h(App)
  }).$mount('#app')
}

// read json and then init
axios.get('/config.json')
  .then(response => {
    store.dispatch('config/setAPIURL', response.data.url.api)
    init()
  })
